import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	linkForecastTaskToTicketMutation,
	LinkForecastTaskToTicketInput,
} from './__generated__/linkForecastTaskToTicketMutation.graphql';

const mutation = graphql`
	mutation linkForecastTaskToTicketMutation($input: LinkForecastTaskToTicketInput!) {
		linkForecastTaskToTicket(input: $input) {
			clientMutationId
			ticket {
				id
				...LinkedTasksTab_ticket
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: LinkForecastTaskToTicketInput,
	onCompleted?: (r: linkForecastTaskToTicketMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<linkForecastTaskToTicketMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'linkForecastTaskToTicketMutation'};
